const ns = {};

/**
 * Parst einfache String-Templates mit den angegebenen Variablen.
 *
 * @param {String} template
 * @param {Object} vars
 * @returns {String}
 */
ns.parse = function (template, vars) {

    var result = (typeof template === 'string') ? template : '';

    Object.keys(vars).forEach(function (el) {

        // kein RegEx-Replace, da sonst ggf. Escaping noetig waere

        var search = '{{' + el + '}}';

        while (result.indexOf(search) > -1) {
            result = result.replace(search, vars[el]);
        }
    });

    return result;
};

export default ns.parse;
